<template>
  <div class="input-dirs" v-loading="loading">
    <h4>Привязка полей к разделу</h4>
    <div style="margin-bottom: 80px; width: 100%">
    <div class="list-inputs">
      <span>Зона работы</span>
      <el-checkbox size="medium" v-model="zone.checked"></el-checkbox>
    </div>
    <div v-for="input in inputs" class="list-inputs">
      <span>{{input.name}}</span>
      <el-checkbox size="medium" v-model="input.checked"></el-checkbox>
    </div>
    </div>

    <div class="input-dirs__buttons">
      <el-button @click="$router.go(-1)">Отмена</el-button>
      <el-button type="primary" @click="update()">Сохранить</el-button>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import _ from 'lodash';
import draggable from 'vuedraggable';
import {getAllInputs} from "../../../firestore/inputs";
import dayjs from "dayjs";

export default {
  name: 'ListDirs',
  components: {draggable},

  data() {
    return {
      loader: false,
      search: '',
      inputs: [],
      loading: false,
      zone: {
        checked: false
      }
    };
  },

  async mounted() {
    this.fetchJobs();
  },

  methods: {
    save: _.debounce(function (el, binding) {
      const inputs = this.inputs.map((input, index) => {
        return {
          ...input,
          _data: {
            ...input._data,
            index: index,
          },
        };
      });

      this.update(inputs);
    }, 1000),

    async fetchJobs() {
      this.loader = true;
      const result = []
      this.zone.checked = (this.$store.state.project.zoneDirs || []).includes(this.$route.params.id)
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('inputs')
        .get()
        .then(async (data) => {
          data.forEach((subDoc) => {
            let _data = subDoc.data();
            delete _data.options;
            result.push({..._data, checked: [...(_data.dirs || [])].includes(this.$route.params.id),  id: subDoc.id});
          });

          if (!result.find(({type}) => type.value === 'population')) {
            const index = result.length + 1

            const project = await firebase.firestore()
              .collection('projects')
              .doc(this.$store.state.project.id)
              .collection('inputs')
              .add({
                name: 'Численность',
                defaultFields: {
                  1: null,
                  2: null,
                  3: null,
                  4: null,
                  5: null,
                },
                isZone: false,
                isEditable: false,
                operation: null,
                dirs: [],
                volumeId: {
                  1: false,
                  2: false,
                  3: false,
                  4: false,
                  5: false
                },
                options: [],
                labels: {
                  1: '',
                  2: '',
                  3: '',
                  4: '',
                  5: ''
                },
                type: {
                  label: 'Численность',
                  value: 'population',
                },
                index,
              })


            result.push({
              name: 'Численность',
              type: {
                label: 'Численность',
                value: 'population',
              },
              id: project.id,
              checked: false,
              index
            })

          }


          if (!result.find(({type}) => type.value === 'tech')) {
            const index = result.length + 1

            const project = await firebase.firestore()
              .collection('projects')
              .doc(this.$store.state.project.id)
              .collection('inputs')
              .add({
                name: 'Техника',
                defaultFields: {
                  1: null,
                  2: null,
                  3: null,
                  4: null,
                  5: null,
                },
                isZone: false,
                isEditable: false,
                operation: null,
                dirs: [],
                volumeId: {
                  1: false,
                  2: false,
                  3: false,
                  4: false,
                  5: false
                },
                options: [],
                labels: {
                  1: '',
                  2: '',
                  3: '',
                  4: '',
                  5: ''
                },
                type: {
                  label: 'Техника',
                  value: 'tech',
                },
                index,
              })


            result.push({
              name: 'Техника',
              type: {
                label: 'Техника',
                value: 'tech',
              },
              id: project.id,
              checked: false,
              index
            })

          }

          this.inputs = [..._.orderBy(result, 'index', ['asc'])]

        }).finally(() => {
        this.loader = false;
      })
    },
    async update() {
      this.loading = true
      const zonesDirs = [...(this.$store.state.project.zoneDirs || [])];


      let n = zonesDirs.indexOf(this.$route.params.id);
      if(n >= 0) {
        zonesDirs.splice(n,1);
      }

      if(this.zone.checked) {
        zonesDirs.push(this.$route.params.id)
      }

      await firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .update({
          zoneDirs: zonesDirs
        })

      this.$store.dispatch('setProject', {
        zoneDirs: zonesDirs,
      });


      let batch = firebase.firestore().batch();

      this.inputs.forEach((doc) => {
        let data = {
          ...doc,
        }

        delete data.id

        if(!data.dirs) {
          data.dirs = []
        }
        let i = data.dirs.indexOf(this.$route.params.id);
        if(i >= 0) {
          data.dirs.splice(i,1);
        }

        if(data.checked) {
          data.dirs.push(this.$route.params.id)
        }

        const docRef = firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('inputs')
          .doc(doc.id);
        batch.update(docRef, data);
      });
      await batch.commit();

      this.$notify.success({
        offset: 60,
        title: 'Успешно',
        message: 'Сохранено',
      });

      this.$router.go(-1);
      this.loading = false

    },
    deleteObject(id) {
      this.$confirm('Вы действительно хотите удалить?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('inputs')
          .doc(id).delete()
          .then((data) => {
            this.$emit('update');
            this.fetchJobs();
            this.$notify({
              offset: 60,
              title: 'Успешно!',
              message: 'удалено',
              type: 'success',
            });
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.input-dirs__buttons {
  z-index: 999;
}
.input-dirs {
  max-width: 420px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  &__buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 420px;

    width: 100%;
    position: fixed;
    bottom: 20px;
  }

  .list-inputs {
    padding: 12px 16px;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(0,0,0,.18);
    height: 48px;
    display: flex;
    flex: 1;
    width: 100%;
    align-items: center;
    justify-content: space-between;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Inputs/Dirs.vue